import { Component, Input, OnInit } from '@angular/core';
import { ChassisFormHandler, ModalService, Model } from '@kaiser-software/chassis-core';
import 'rxjs/add/operator/first';
import { Subject } from 'rxjs/Subject';
import { CategoryModel } from '../../models/category.model';

@Component({
    selector: 'app-category-plugin',
    templateUrl: 'category.plugin.html',
    styleUrls: [ 'category.plugin.scss' ]
})
export class CategoryPlugin implements OnInit {

    @Input() public model: Subject<Model>;

    @Input() public form: ChassisFormHandler;

    public category: CategoryModel;

    constructor(private modals: ModalService) {
    }

    ngOnInit() {
        this.model.subscribe((model: any) => {
            this.category = model.category;
        });
    }

    // public openSelectCategoryModel() {
    //     const modal = this.modals.open(SelectCategoryModal);
    //
    //     modal.result.then((categoryModel: CategoryModel) => {
    //         this.category.next(categoryModel);
    //
    //         this.model.subscribe((model: Model) => {
    //             model[ 'category' ] = categoryModel;
    //         });
    //     }, (reject) => {
    //         console.log(reject);
    //     });
    // }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/plugins/category/category.plugin.ts